import { FormControl, TextField } from "@mui/material";
import { useEffect } from "react";

const UDatePickers = (props) => {
    const dateNow = new Date(); 
    const today = dateNow.toISOString().slice(0, 10);
    const startLabel = props.startLabel || 'fromDate';
    const endLabel = props.endLabel || 'toDate';
    const startDate = props.startDate;
    const endDate = props.endDate;
    let type = props.type;
    if(!type) type="date";
    
    return(
        type==='date'?
        (<>{/* TPYE: DATE */}
            <FormControl sx={{ width: 140 }}>
                <TextField
                    label={startLabel}
                    name="startDate"
                    type="date"
                    size="small"
                    defaultValue={startDate||today}
                    variant="outlined"
                    id="outlined-basic"
                    onChange={props.onChange}
                    inputProps={{style: {fontSize: 13}}} // font size of input text
                />
            </FormControl>
            <FormControl sx={{ width: 140 }}>
                <TextField
                    label={endLabel}
                    name="endDate"
                    type="date"
                    size="small"
                    defaultValue={endDate||today}
                    variant="outlined"
                    id="outlined-basic"
                    onChange={props.onChange}
                    inputProps={{style: {fontSize: 13}}} // font size of input text
                />
            </FormControl></>
        ):(<>{/* TPYE: TIME */}
            <FormControl sx={{ maxWidth: 150 }}>
                <TextField
                    label={startLabel}
                    name="startTime"
                    size="small"
                    defaultValue="00:00:00"
                    variant="outlined"
                    id="outlined-basic"
                    onChange={props.onChange}
                    inputProps={{style: {fontSize: 13}}} // font size of input text
                />
            </FormControl>
            &nbsp;&nbsp;&nbsp;~
            <FormControl sx={{ maxWidth: 150 , mr: 2}}>
                <TextField
                    label={endLabel}
                    name="endTime"
                    size="small"
                    defaultValue="23:59:59"
                    variant="outlined"
                    id="outlined-basic"
                    onChange={props.onChange}
                    inputProps={{style: {fontSize: 13}}} // font size of input text
                />
            </FormControl></>)
        );
};
export default UDatePickers;